import { render, staticRenderFns } from "./create-vault-customer.vue?vue&type=template&id=4500e6fe&scoped=true"
import script from "./create-vault-customer.vue?vue&type=script&lang=js"
export * from "./create-vault-customer.vue?vue&type=script&lang=js"
import style0 from "./create-vault-customer.vue?vue&type=style&index=0&id=4500e6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4500e6fe",
  null
  
)

export default component.exports